import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=a5d13baa"
import script from "./Localization.vue?vue&type=script&lang=js"
export * from "./Localization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports